export const SERVICE_STATUS = {
    PENDING: 'pending',
    IN_PROGRESS: 'in_progress',
    DONE: 'done',
    ERROR: 'error',
    SKIPPED: 'skipped'
} as const
